import React from "react";
import { Link } from "react-router-dom";
import "./NotFound.css";

function NotFound() {
  return (
    <div className="notfound-page">

      <div className="notfound-glow notfound-glow-one"></div>
      <div className="notfound-glow notfound-glow-two"></div>

      <div className="notfound-content">

        <div className="notfound-code">
          <span>4</span>

          <div className="notfound-zero">
            <div className="notfound-fiber-ring"></div>
            <div className="notfound-fiber-core"></div>
          </div>

          <span>4</span>
        </div>

        <div className="notfound-eyebrow">
          SIGNAL LOST
        </div>

        <h1>
          Looks like this connection
          <br />
          didn’t make it through.
        </h1>

        <p>
          The page you’re looking for may have moved,
          changed names, or no longer exists.
        </p>

        <div className="notfound-actions">
          <Link
            to="/"
            className="notfound-primary"
          >
            Return Home
          </Link>

          <Link
            to="/products"
            className="notfound-secondary"
          >
            Explore Products
          </Link>
        </div>

        <div className="notfound-path">
          <span className="notfound-node"></span>
          <span className="notfound-line"></span>
          <span className="notfound-node active"></span>
          <span className="notfound-line broken"></span>
          <span className="notfound-node lost"></span>
        </div>

        <div className="notfound-path-labels">
          <span>Go!Foton</span>
          <span>Network</span>
          <span>Lost Page</span>
        </div>

      </div>

    </div>
  );
}

export default NotFound;